import { render, staticRenderFns } from "./UploadPreviewDialog.vue?vue&type=template&id=4c1898a8"
import script from "./UploadPreviewDialog.vue?vue&type=script&lang=js"
export * from "./UploadPreviewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports